// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_mediapipe_holistic_holistic_js-node_modules_kalmanjs_lib_kalman_js-node_-ff605e"], () => (__webpack_require__("./src/worker/pose-processing.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
